import { ModuleBase } from '@/presentation/configuration/modules/ModuleBase'
import { ProfileRepository } from '@/core/infrastructure/repositories/profile/ProfileRepository.ts'
import { FetchMeUseCase } from '@/core/useCases/profile/FetchMeUseCase.ts'

export class ProfileModule extends ModuleBase {
  initialize(): void {
    this.initializeCore()
  }

  private initializeCore(): void {
    const profileRepository = new ProfileRepository()
    this.registerRepository(ProfileRepository, profileRepository)

    const getMeUseCase = new FetchMeUseCase(profileRepository)
    this.registerUseCase(FetchMeUseCase, getMeUseCase)
  }
}
